export const createFlightsRequests = (client) => ({
    listFlights: async (params) => {
        const { data, meta, links } = await client.api.get("flights", {
            params: params,
        });
        return { data, meta, links };
    },
    findFlight: async (params) => {
        const { data } = await client.api.get(`flights/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createFlight: async (payload) => {
        const { data } = await client.api.create("flights", payload);
        return { data };
    },
    updateFlight: async (flightId, payload) => {
        const { data } = await client.api.update("flights", {
            id: flightId,
            ...payload,
        });
        return { data };
    },
    deleteFlight: async (flightId) => {
        await client.api.remove("flights", flightId);
    },
    addEntriesToFlight: async (flightId, entryIds) => {
        await client.api.request({
            type: "flight",
            url: `/flights/${flightId}/entries`,
            method: "POST",
            body: { entryIds },
        });
    },
    removeEntryFromFlight: async (flightId, entryId) => {
        await client.api.request({
            type: "flight",
            url: `/flights/${flightId}/entries/${entryId}`,
            method: "DELETE",
        });
    },
    assignFlightToTable: async (flightId, tableId) => {
        const { data } = await client.api.request({
            type: "flight",
            url: `/flights/${flightId}/assign`,
            method: "POST",
            body: { contestsEditionStageTableId: tableId },
        });
        return { data };
    },
    closeFlight: async (flightId) => {
        const { data } = await client.api.request({
            type: "flight",
            url: `/flights/${flightId}/consensus`,
            method: "POST",
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map